import { createAction, props } from '@ngrx/store';
import { BoelsReservation } from '@boels/models';

export const loadHolidays = createAction(
  '[Holidays] Load Holidays in Time range',
  props<{ startDate: string; endDate: string }>(),
);

export const loadHolidaysSuccess = createAction(
  '[Holidays] Load Holidays success',
  props<{ holidays: BoelsReservation }>(),
);

export const loadHolidaysFail = createAction('[Holidays] Load Holidays failed');
